// extracted by mini-css-extract-plugin
module.exports = {"title-1":"title_title-1__gQCl2","title-2":"title_title-2__KyIDs","title-3":"title_title-3__V1rv4"};